import { Header } from "../../Components/index";
import { Fragment } from "react";

import { useTranslation } from "react-i18next";

import "./news.css";
const News = () => {
  const { t } = useTranslation();
  const newsDetails = t("newsDetails", { returnObjects: true });

  return (
    <Fragment>
      <Header
        bgTitle={document.body.dir === "ltr" ? "NEWS" : "الاخبار"}
      ></Header>
      <section className="news">
        <div className="container news__container">
          {newsDetails &&
            newsDetails.map(({ id, title, link, photo }) => {
              return (
                <article key={id}>
                  <img src={photo} alt="theImage" />
                  <div className="news__details">
                    <h3>{title}</h3>
                    <a
                      href={link}
                      className="btn"
                      target="_blank"
                      rel="noreferrer"
                    >
                      {t("see_btn")}
                    </a>
                  </div>
                </article>
              );
            })}
        </div>
      </section>
    </Fragment>
  );
};

export default News;
